import { Action } from 'helpers/action-helpers';
import { Alert } from 'types/alert';
import { OperationItem } from 'types/operation-item';

export const MANUAL_ENTRY = 'ManualEntryAction';
export const SCANDIT_ENTRY = 'ScanditEntryAction';
export const LIST_ALERTS = 'ListAlertsAction';
export const SET_ALERTS = 'SetAlertsAction';
export const DELETE_ALERT = 'DeleteAlertAction';
export const RETRY_ERRONEOUS_ITEM = 'RetryErroneousItemAction';
export const SCAN_ATTEMPT = 'ScanAttemptAction';

export class ManualEntryAction extends Action {
  constructor(public epc: string) { 
    super(MANUAL_ENTRY);
  }
}

export class ScanditEntryAction extends Action {
  constructor(public epc: string) { 
    super(SCANDIT_ENTRY);
  }
}

export class ListAlertsAction extends Action {
  constructor() { 
    super(LIST_ALERTS);
  }
}

export class SetAlertsAction extends Action {
  constructor(public alerts: Alert[]) { 
    super(SET_ALERTS);
  }
}

export class DeleteAlertAction extends Action {
  constructor(public clientTransactionId: string, public username: string) { 
    super(DELETE_ALERT);
  }
}

export class RetryErroneousItemAction extends Action {
  constructor(public operationItem: OperationItem) { 
    super(RETRY_ERRONEOUS_ITEM);
  }
}

export class ScanAttemptAction extends Action {
  constructor(public output: string) { 
    super(SCAN_ATTEMPT);
  }
}


// WEBPACK FOOTER //
// ./src/components/main/actions.ts